import {ORDER_MAKER_GETTER_WEIGHT_ADJUSTMENT} from "./types";

export default {
    [ORDER_MAKER_GETTER_WEIGHT_ADJUSTMENT]: (state) => {
        return state.weightAdjustment;
    },
}